import { component } from 'picoapp';
import choozy from 'choozy';
import { on, qs, add, remove } from '@selfaware/martha';
import { subscribe } from 'klaviyo-subscribe';

export default component((node, ctx) => {
  let { formContent, success, submit, error } = choozy(node);

  let listId;

  on(submit, 'click', (e) => {
    e.preventDefault();

    listId = window.location.pathname.includes('/wholesale') ? 'RWP2yA' : 'WfxYAi';
    let email = qs('.js-email', node).value;
    let phone = qs('.js-phone', node).value;
    let consent = qs('.consent', node).checked;

    // Format the phone number correctly (E.164 format)
    phone = phone.replace(/[^0-9]/g, ''); // Remove any non-numeric characters
    if (!phone.startsWith('+')) {
      phone = `+1${phone}`; // Assuming US country code, adjust as necessary
    }

    console.log({ email, phone, consent });

    if (email && phone && consent) {
      subscribe(listId, email, {
        $phone_number: phone,
        $consent: ['sms'], // Ensure SMS consent is included
      })
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            // Check if the subscription was successful
            remove(success, 'hidden');
            add(formContent, 'hidden');
            add(error, 'hidden');

            if (qs('.js-formTitle')) {
              add(qs('.js-formTitle'), 'hidden');
            }
          } else {
            console.error('Klaviyo subscription error:', response);
            remove(error, 'hidden');
          }
        })
        .catch((err) => {
          console.error('Error subscribing to Klaviyo:', err);
          remove(error, 'hidden');
        });
    } else {
      remove(error, 'hidden');
    }
  });
});
